export const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,15}$/i;
export const httpsUrlPattern = /^(https:\/\/www\.|https:\/\/)+[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i;
export const uuidPattern = /\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b/;
export const passwordPattern = /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{7,}/;
export const hexColorRegex = /^#(?:[0-9a-fA-F]{3}){1,2}$/;
export const numbersPattern = /^[0-9\b]+$/;
